module.exports = __webpack_public_path__ + "img/Banner-Quanta-Bank-02.04a94fbc.jpg";